import { Article } from '../types';
import axiosConnector from "./axiosConnector";
import { toArticleDTO } from "../dto/articleDTO";
import { API_URL } from './axiosConnector';

interface PaginatedImagesResponse {
  data?: Article[];
  pagination?: {
    total_records: number;
    current_page: number;
    total_pages: number;
    next_page: number | null;
    prev_page: number | null;
  };
}

export const getImages = async (page: number = 1, limit: number = 10): Promise<{ data: Article[], pagination: { total_records: number, current_page: number, total_pages: number, next_page: number | null, prev_page: number | null } }> => {
  try {
    const imagesResponse = await axiosConnector.get<PaginatedImagesResponse | Article[]>(`${API_URL}/images?page=${page}&limit=${limit}&sort_by=created_at&sort_order=desc`);
    const responseData = imagesResponse.data;
    
    // Check if response has pagination structure
    if (responseData && typeof responseData === 'object' && 'data' in responseData && 'pagination' in responseData) {
      return {
        data: responseData.data || [],
        pagination: responseData.pagination || {
          total_records: 0,
          current_page: 1,
          total_pages: 0,
          next_page: null,
          prev_page: null
        }
      };
    }
    
    // Fallback for non-paginated response (array of images)
    const imagesArray = Array.isArray(responseData) ? responseData : [];
    return {
      data: imagesArray,
      pagination: {
        total_records: imagesArray.length,
        current_page: 1,
        total_pages: 1,
        next_page: null,
        prev_page: null
      }
    };

  } catch (error) {
    console.error(error);
    return {
      data: [],
      pagination: {
        total_records: 0,
        current_page: 1,
        total_pages: 0,
        next_page: null,
        prev_page: null
      }
    };
  }
};

export interface UploadImageResponse {
  id: string;
  image_url: string;
}

export const uploadImage = async (file: File, options: { type: 'profile' | 'story' | 'article' | 'imageType' | 'processed' }): Promise<UploadImageResponse> => {
  try {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('type', options.type);
    const response = await axiosConnector.post<UploadImageResponse>(`${API_URL}/images/`, formData);

    if (!response.data) {
      throw new Error('Failed to upload image');
    }

    return response.data;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
}; 